import request from '@/router/axios'

export function getPage(params) {
    return request({
        url: '/chain/drivertask/driverTaskList',
        method: 'get',
        params
    })
}
export function drivertruckinfo(params) {
    return request({
        url: '/chain/drivertruckinfo/page',
        method: 'get',
        params
    })
}

